//  icons
import {
  FiCode,
  FiDatabase,
  FiFacebook,
  FiGithub,
  FiImage,
  FiLayout,
  FiLinkedin,
  FiMail,
  FiMapPin
} from "react-icons/fi";
import BehanceBrandIcon from "./assets/img/brands/behance.png";
import DribbbleBrandIcon from "./assets/img/brands/dribbble.png";
import FiverBrandIcon from "./assets/img/brands/fiverr.png";
// companies icons
import FreelancerBrandIcon from "./assets/img/brands/freelancer.png";
import UpworkBrandIcon from "./assets/img/brands/upwork.png";
import SkillImg2 from "./assets/img/skills/css3.png";
import SkillImg7 from "./assets/img/skills/express.png";
import SkillImg10 from "./assets/img/skills/figma.png";
import SkillImg9 from "./assets/img/skills/git.png";
// skills images
import SkillImg1 from "./assets/img/skills/html5.png";
import SkillImg3 from "./assets/img/skills/js.png";
import SkillImg5 from "./assets/img/skills/mongodb.png";
import SkillImg6 from "./assets/img/skills/nodejs.png";
import SkillImg4 from "./assets/img/skills/reactjs.png";
import SkillImg8 from "./assets/img/skills/wordpress.png";
// testimonial images
import TestiImage1 from "./assets/img/testimonials/testimonial-1.webp";
import TestiImage2 from "./assets/img/testimonials/testimonial-2.webp";
import TestiImage3 from "./assets/img/testimonials/testimonial-3.webp";

// navigation
export const navigation = [
  {
    name: "home",
    href: "home",
  },
  {
    name: "about",
    href: "about",
  },
  {
    name: "projects",
    href: "projects",
  },
  {
    name: "services",
    href: "services",
  },
  {
    name: "testimonials",
    href: "testimonials",
  },
  {
    name: "contact",
    href: "contact",
  },
];

// social
export const social = [
  {
    icon: <FiFacebook />,
    href: "https://www.facebook.com/ashrafulislam1659/",
  },
  {
    icon: <FiLinkedin />,
    href: "https://www.linkedin.com/in/developerashrafulislam/",
  },

  {
    icon: <FiGithub />,
    href: "https://github.com/ashrafulislampro/",
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: "",
  },
  {
    img: UpworkBrandIcon,
    href: "",
  },
  {
    img: FiverBrandIcon,
    href: "",
  },
  {
    img: BehanceBrandIcon,
    href: "",
  },
  {
    img: DribbbleBrandIcon,
    href: "",
  },
];
// https://online-money-bd.netlify.app/
// projects
export const projectsData = [
  {
    id: "1",
    image: "https://i.ibb.co/s5dvBHh/project22.png",
    name: "Travel Thirsty",
    category: "Team Project",
    description:
      "This website is a manufacturer company website. users can signin and buy product from here.This website has some feature and functionality.This website create in React.",
    githubClient: "https://github.com/ashrafulislampro/travel-thirsty-client",
    githubServer:
      "https://github.com/ashrafulislampro/tour-app-server-node-js-",
    LiveLink: "https://travel-thirsty.web.app/",
  },

  {
    id: "2",
    image: "https://i.ibb.co/bJcG8Vp/project23.png",
    name: "Dezily",
    category: "Team Project",
    description:
      "Dezily is a Hospital website. This website explain about an International Hospital information. There have every Doctor Treatments details and state of disease. This website has some feature and functionality.This website create with React.",
    githubClient: "https://github.com/ashrafulislampro/dezily",
    githubServer: "",
    LiveLink: "",
  },
  {
    id: "3",
    image: "https://i.ibb.co/zFnHRPk/project-1.png",
    name: "Embossed",
    category: "Team Project",
    description:
      "This website is a manufacturer e-commerce website. users can signin and buy product from here.This website has some feature and functionality.This website create with React.",
    githubClient:
      "https://github.com/ashrafulislampro/Embossed-Project/tree/master/frontend",
    githubServer:
      "https://github.com/ashrafulislampro/Embossed-Project/tree/master/backend",
    LiveLink: "https://embossed-e-commerce.web.app/",
  },
  {
    id: "4",
    image: "https://i.ibb.co/rdx0WCV/project3.png",
    name: "Dorext",
    category: "MERN Stack Project",
    description:
      "Its an Independent Service Provider Website About Travel in the Historical Place whole over the world.Users can buy the tour package which is they wanted. This Website Build in MERN Stack Project.",
    githubClient:
      "https://github.com/ashrafulislampro/Dorext/tree/main/dorext-client",
    githubServer:
      "https://github.com/ashrafulislampro/Dorext/tree/main/dorext-server",
    LiveLink: "https://dorext-88fcc.web.app",
  },
  {
    id: "5",
    image: "https://i.ibb.co/xgqQ7Fd/project2.png",
    name: "Qutir Mahal",
    category: "MERN Stack Project",
    description:
      "Manufacturer e-commerce company website. users must have to signin if they buy tour from here.There are some feature and functionality.This website creation with MERN Stack.",
    githubClient: "https://github.com/ashrafulislampro/Qutir-Mahal-Client",
    githubServer: "https://github.com/ashrafulislampro/Qutir-Mahal-Server",
    LiveLink: "https://qutir-mahal.web.app/",
  },
  {
    id: "6",
    image: "https://i.ibb.co/sJ6gVyd/project6.png",
    name: "Tunicalabs Media",
    category: "MERN Stack Project",
    description:
      "This is a student Data entry website. Admin can add new Students, update student info and delete student from the website.This Website Build in React, Node, Express, MongoDB.",
    githubClient: "https://github.com/ashrafulislampro/Tunicalabs-Client",
    githubServer: "https://github.com/ashrafulislampro/Tunicalabs-Server",
    LiveLink: "https://tunicalabs-media.web.app/",
  },
  {
    id: "7",
    image: "https://i.ibb.co/swRChwf/project4.png",
    name: "Dental Clinic",
    category: "Simple React Project",
    description:
      "Its a Simple Dental Clinic Website that Explore there Dentallist and there Appointment. There has many Doctors for treatments. It is created with React with Context API.",
    githubClient: "https://github.com/ashrafulislampro/Dental-Clinic",
    LiveLink: "https://dental-clinic-1a8c1.web.app",
  },
  {
    id: "8",
    image: "https://i.ibb.co/Kw6sCsm/image.png",
    name: "Crypto Currency",
    category: "Simple React Project",
    description:
      "This is Marketplace client project. users can know about Crypto currency from here.This website has some feature and functionality.This website create in React.",
    githubClient:
      "https://github.com/moazzemhossainnahid/warehouse-management-client",
    githubServer: "",
    LiveLink: "https://crypto-currency-projects.netlify.app/",
  },
  {
    id: "9",
    image: "https://i.ibb.co/p2R9HmP/project13.png",
    name: "Pin Matcher",
    category: "JavaScript ES6",
    description:
      "Its a Simple Pin Matcher Website. If User click generate pin button display show random pin and then both of the pin matching it show a successful sms. Its Build in HTML, CSS, JavaScript ES6.",
    githubClient: "https://github.com/ashrafulislampro/Pin-Matcher-Project",
    LiveLink: "https://ashrafulislampro.github.io/Pin-Matcher-Project/",
  },
  {
    id: "10",
    image: "https://i.ibb.co/3MgXfKq/project14.png",
    name: "Issue Tracker",
    category: "JavaScript ES6",
    description:
      "This a Simple Issue Tracker Website. User can inform there Issue for the authorizer in this website and they can close or delete the issue. Its Build in HTML, CSS, JavaScript ES6.",
    githubClient:
      "https://github.com/ashrafulislampro/Issue-Tracker-Practice-Problem",
    LiveLink:
      "https://ashrafulislampro.github.io/Issue-Tracker-Practice-Problem/",
  },
  {
    id: "11",
    image: "https://i.ibb.co/Ns9gn7t/project7.png",
    name: "Shopping Cart",
    category: "JavaScript ES6",
    description:
      "Its a Simple Shopping Cart Website. User can add product and can remove product with there Opinions. Its Build in HTML, CSS, JavaScript ES6.",
    githubClient: "https://github.com/ashrafulislampro/Shopping-Cart-Project",
    LiveLink: "https://ashrafulislampro.github.io/Shopping-Cart-Project/",
  },
  {
    id: "12",
    image: "https://i.ibb.co/J3Vvtqd/project12.png",
    name: "Weather App",
    category: "JavaScript ES6",
    description:
      "Its a Simple Weather APP Website. User can search any city the app show the specific weather of the place. Its Build in HTML, CSS, JavaScript ES6.",
    githubClient: "https://github.com/ashrafulislampro/Weather-App-Project",
    LiveLink: "https://ashrafulislampro.github.io/Weather-App-Project/",
  },
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "MERN Stack Project",
  },

  {
    name: "Team Project",
  },
  {
    name: "Simple React Project",
  },
  {
    name: "JavaScript ES6",
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
  {
    image: SkillImg9,
  },
  {
    image: SkillImg10,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: "Web Design",
    description:
      "Design any type Web Structure to build an unique design for website.",
  },
  {
    icon: <FiCode />,
    name: "Web Development",
    description:
      "Develop any type of Website in JavaScript, React, Firebase, Node, Express, MongoDB",
  },
  {
    icon: <FiDatabase />,
    name: "Wordpress",
    description:
      "Build Website in Wordpress use Elementor plugin with Divi, Avada theme.",
  },
  {
    icon: <FiImage />,
    name: "Graphics Design",
    description: "Design Graphics for Website Banner or Structure as needed. ",
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage2,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage3,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: "Have a question?",
    subtitle: "I am here to help you.",
    phone: "+880-1303960837",
    description: `ashrafulislam1659@gmail.com`,
  },
  {
    icon: <FiMapPin />,
    title: "Current Location",
    subtitle: "Narsingdi, Dhaka, Bangladesh",
    description: "Serving clients worldwide",
  },
];
